import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiMembersMeetingNoteMutateType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    title: string;
    content: RawDraftContentState;
    postDate: string;
    meetingNoteTemplateId?: string;
    attachFiles?: File[];
    participationEmployeeIds: string[];
  };
};

const request = ({ id, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ meetingNote: body });
  return new ApiClient()
    .put<ApiMembersMeetingNoteMutateType>(
      `/api/members/meeting_notes/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersMeetingNotesUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersMeetingNoteMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
